import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import { MaterialUIControllerProvider } from 'context';
import { store } from './redux/store';
import { Provider } from 'react-redux';

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOLS_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOLS_WEB_CLIENT_ID,
      loginWith: {
        username: true,
      },
    },
  },
  API: {
    REST: {
      'deltaSnp-api': {
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        region: process.env.REACT_APP_PROJECT_REGION,
      },
    },
  },
};

Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
